module.exports = __webpack_public_path__ + "images/emoji/cat2.b0667b89ab1f16b41bcf.png";